import _defineProperty from "/Volumes/DustedRepos/htb/htb-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/Volumes/DustedRepos/htb/htb-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { adaptFacetConfig, adaptFilterConfig, adaptResultFieldsConfig, adaptSearchFieldsConfig } from "./requestAdapters";
export default function adaptRequest(requestState, queryConfig, documentType) {
  var disjunctiveFacets = queryConfig.disjunctiveFacets,
      disjunctiveFacetsAnalyticsTags = queryConfig.disjunctiveFacetsAnalyticsTags;

  if (disjunctiveFacets) {
    console.warn("search-ui-site-search-connector: disjunctiveFacets is not supported by Site Search");
  }

  if (disjunctiveFacetsAnalyticsTags) {
    console.warn("search-ui-site-search-connector: disjunctiveFacetsAnalyticsTags is not supported by Site Search");
  }

  var updatedFacets = adaptFacetConfig(queryConfig.facets);
  var updatedFilters = adaptFilterConfig(queryConfig.filters !== undefined ? queryConfig.filters : requestState.filters);
  var page = queryConfig.current !== undefined ? queryConfig.current : requestState.current;
  var per_page = queryConfig.resultsPerPage !== undefined ? queryConfig.resultsPerPage : requestState.resultsPerPage;
  var sortDirection = queryConfig.sortDirection !== undefined ? queryConfig.sortDirection : requestState.sortDirection;
  var sortField = queryConfig.sortField !== undefined ? queryConfig.sortField : requestState.sortField;
  var sortList = queryConfig.sortList !== undefined ? queryConfig.sortList : requestState.sortList;

  var _adaptResultFieldsCon = adaptResultFieldsConfig(queryConfig.result_fields),
      _adaptResultFieldsCon2 = _slicedToArray(_adaptResultFieldsCon, 2),
      fetchFields = _adaptResultFieldsCon2[0],
      highlightFields = _adaptResultFieldsCon2[1];

  var updatedSearchFields = adaptSearchFieldsConfig(queryConfig.search_fields);
  var searchTerm = requestState.searchTerm;
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, per_page && {
    per_page: per_page
  }), page && {
    page: page
  }), sortDirection && {
    sort_direction: _defineProperty({}, documentType, sortDirection)
  }), sortField && {
    sort_field: _defineProperty({}, documentType, sortField)
  }), sortList && {
    sort_list: _defineProperty({}, documentType, sortList)
  }), updatedFilters && {
    filters: _defineProperty({}, documentType, updatedFilters)
  }), updatedFacets && {
    facets: _defineProperty({}, documentType, updatedFacets)
  }), fetchFields && {
    fetch_fields: _defineProperty({}, documentType, fetchFields)
  }), highlightFields && {
    highlight_fields: _defineProperty({}, documentType, highlightFields)
  }), updatedSearchFields && !!updatedSearchFields.length && {
    search_fields: _defineProperty({}, documentType, updatedSearchFields)
  }), {
    q: searchTerm
  });
}